import React from 'react';
import { CheckIcon, TargetIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
import { volumes, MOCKUP_URL } from '../../data/content';
export function Volumes() {
  return <section className="w-full bg-ink py-16 sm:py-24" data-id="element-340" data-mp="2wzgpl3bkxy45">
      <div className="mx-auto max-w-5xl px-4" data-id="element-341" data-mp="2t0g5zila2rg3">
        <SectionHeading kicker="Everything you need to organize your next no-start investigation" title={<>Get 6 practical <span className="text-brand" data-id="element-343" data-mp="2ja50hrly4a73">diagnostic volumes</span></>} subtitle="Each volume focuses on a specific diagnostic responsibility and provides practical tools for real workshop investigations." data-id="element-342" data-mp="2t1rc3p274bad" />

        <img src={MOCKUP_URL} alt="The six diagnostic volumes" className="mx-auto mt-8 w-full max-w-3xl" data-id="element-344" data-mp="29cqnk1z8e3jj" />

        <div className="mt-12 space-y-8" data-id="element-345" data-mp="258sn9ny66mow">
          {volumes.map(v => <article key={v.number} className="overflow-hidden rounded-3xl border border-line bg-panel" data-id="element-346" data-mp="20ahgjm368saw">
              <div className="flex items-center gap-3 bg-alert px-5 py-3" data-id="element-347" data-mp="335dz9bfpp27q">
                <span className="font-display text-xl font-black uppercase text-white" data-id="element-348" data-mp="37w2sowayc99i">Volume {v.number}</span>
              </div>
              <div className="p-5 sm:p-8" data-id="element-349" data-mp="2u5zd2o6kvdt1">
                <h3 className="font-display text-3xl font-black uppercase leading-[1.02] text-white sm:text-4xl" data-id="element-350" data-mp="2u2v31a6flnug">{v.title}</h3>
                <p className="mt-2 font-display text-xl font-bold leading-snug text-brand sm:text-2xl" data-id="element-351" data-mp="3lwdma73nc1yd">{v.tagline}</p>
                <div className="mt-4 space-y-2 text-base leading-relaxed text-body sm:text-lg" data-id="element-352" data-mp="3qvgshuvd4e7x">
                  {v.intro.map(p => <p key={p} data-id="element-353" data-mp="3cv5zomahspk4">{p}</p>)}
                </div>

                <div className="mt-6 grid gap-6 md:grid-cols-[1.3fr_1fr]" data-id="element-354" data-mp="3ht7egv0vy2ps">
                  <div data-id="element-355" data-mp="21g0t3778q6v8">
                    <p className="font-display text-lg font-bold uppercase tracking-wide text-muted" data-id="element-356" data-mp="21fh7ngidt0cg">Inside this volume:</p>
                    <ul className="mt-3 space-y-2.5" data-id="element-357" data-mp="26dahcjiw8chh">
                      {v.items.map(item => <li key={item} className="flex items-start gap-2.5 text-base text-white" data-id="element-358" data-mp="c19es0g4p26y">
                          <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-ok" strokeWidth={3} aria-hidden="true" data-id="element-359" data-mp="7251axm68iat" />
                          {item}
                        </li>)}
                    </ul>
                  </div>
                  <div className="flex flex-col gap-4" data-id="element-360" data-mp="3pf2xctfueqzp">
                    <div className="rounded-2xl bg-ink p-4" data-id="element-361" data-mp="3pbowxqqqoruw">
                      <p className="flex items-center gap-2 font-display text-lg font-bold uppercase text-ok" data-id="element-362" data-mp="3kddkd892838z">
                        <TargetIcon className="h-5 w-5" aria-hidden="true" data-id="element-363" data-mp="3fg5arw1z97jc" />
                        Your practical result
                      </p>
                      <p className="mt-2 text-base text-white" data-id="element-364" data-mp="1dp0n1b360r4a">{v.result}</p>
                    </div>
                    {v.quote && <p className="border-l-4 border-brand pl-4 font-display text-2xl font-bold italic leading-tight text-white" data-id="element-365" data-mp="19nf2r4oaxak2">
                        {v.quote}
                      </p>}
                  </div>
                </div>
              </div>
            </article>)}
        </div>

        <CtaButton className="mt-12" label="Get All 6 Volumes Now — $27" data-id="element-366" data-mp="31cg3i4gxk4n5" />
      </div>
    </section>;
}